import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=c831ed86&"
import script from "./OptionList.vue?vue&type=script&lang=js&"
export * from "./OptionList.vue?vue&type=script&lang=js&"
import style0 from "./OptionList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports